import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import ServiceDetails from './pages/ServiceDetails';
import FaceRecognition from './pages/FaceRecognition';
import OCR from './pages/OCR';
import ObjectDetection from './pages/ObjectDetection';
import TextSummarization from './pages/TextSummarization';
import LanguageTranslation from './pages/LanguageTranslation';
import SentimentAnalysis from './pages/SentimentAnalysis';
import Chatbots from './pages/Chatbots';
import RecommendationSystems from './pages/RecommendationSystems';
import TimeSeriesForecasting from './pages/TimeSeriesForecasting';
import Agents from './pages/Agents';
import Portfolio from './pages/Portfolio';

const AppRoutes = () => (
  <Router>
    <MainLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        {/* <Route path="/services/:serviceName" element={<ServiceDetails />} /> */}
        <Route path="/services/ai-agents" element={<Agents />} />
        <Route path="/services/face-recognition" element={<FaceRecognition />} />
        <Route path="/services/ocr" element={<OCR />} />
        <Route path="/services/object-detection" element={<ObjectDetection />} />
        <Route path="/services/text-summarization" element={<TextSummarization />} />
        <Route path="/services/language-translation" element={<LanguageTranslation />} />
        <Route path="/services/sentiment-analysis" element={<SentimentAnalysis />} />
        <Route path="/services/chatbots" element={< Chatbots/>} />
        <Route path="/services/recommendation-systems" element={<RecommendationSystems />} />
        <Route path="/services/time-series-forecasting" element={<TimeSeriesForecasting />} />
      </Routes>
    </MainLayout>
  </Router>
);

export default AppRoutes;